export function buildCommonFetchOptions(formData, onProgress){
  let options = {
    method: 'POST',
    body: formData
  };

  if (onProgress) {
    options.events = {
      onprogress: function (e) {
        if (e.lengthComputable) {
          onProgress(e.loaded, e.total, false);
        }
      },
      onloadstart: function (e) {
        if (e.lengthComputable) {
          onProgress(e.loaded, e.total, false);
        }
      },
      onloadend: function (e) {
        if (e.lengthComputable) {
          onProgress(e.loaded, e.total, true);
        }
      }
    }
  }

  return options;
}
